import api from "api/api";
import _ from "lodash";

export const getClientsByIdArray = async ({ ids, userScope }) => {
  const scopeParam = userScope ? `?scope=${userScope}` : "";
  return await api.get(`/directory/client/ids/${ids}${scopeParam}`);
};

export const createClientQuery = async ({ data, userScope }) =>
  await api.post(`/directory/client?scope=${userScope}`, data);

export const getClientByIdQuery = async ({ id }) =>
  await api.get(`/directory/client/id/${id}`);

export const updateClientQuery = async ({ id, data, userScope }) =>
  await api.put(`/directory/client/${id}?scope=${userScope}`, data);

export const deleteClientQuery = async ({ id, userScope }) =>
  await api.delete(`/directory/client/${id}?scope=${userScope}`);

export const getClientBySlugQuery = async ({ slug, userScope }) =>
  await api.get(`/directory/client/slug/${slug}?scope=${userScope}`);

export const getClientBySearchQuery = async ({
  page,
  search,
  status,
  filters,
  userScope,
}) => {
  const params = new URLSearchParams();
  if (userScope) params.append("scope", userScope);
  if (page) params.append("page", page);
  if (search) params.append("search", search);
  if (Array.isArray(status) && status.length > 0) {
    status.forEach((el) => params.append("mission_status", el));
  }
  if (!_.isEmpty(filters)) {
    params.append("order", filters.order);
    params.append("order_dir", filters.order_dir);
  }
  const queryString = params.toString();
  return await api.get(`/directory/search/missions-client?${queryString}`);
};

export const getClientBillingAddressByIdQuery = async ({ id, userScope }) =>
  await api.get(
    `/directory/client/id/${id}/billing_client_address?scope=${userScope}`
  );

export const getAssignedClientsByUserIdQuery = async ({ scope, manager_id }) =>
  await api.get(
    `directory/client/manager/tab?scope=${scope}&manager_id=${manager_id}`
  );

export const patchClientTrafficLightQuery = async ({
  client_id,
  traffic_light_value,
}) =>
  await api.patchTextPlain(
    `/directory/traffic_light/${client_id}`,
    traffic_light_value
  );

export const releaseClientQuery = async (client_id) =>
  await api.post(`/directory/client/${client_id}/detach`);

export const askAssignationByIdQuery = async ({ id, assignment_type }) =>
  await api.post(`/directory/${assignment_type}/${id}/assign`);

export const getAssignmentyRequestAnswerQuery = async ({
  userScope,
  id,
  requester_id,
  assignment_type,
}) =>
  await api.get(
    `/directory/${assignment_type}/answer?scope=${userScope}&${assignment_type}_id=${id}&requester_id=${requester_id}`
  );

export const updateAnswerAssignmentQuery = async ({
  answer_id,
  data,
  assignment_type,
}) =>
  await api.put(
    `/directory/${assignment_type}/answer?answer_id=${answer_id}`,
    data
  );
